import React, { memo, useState } from 'react';
import { DatePicker, Modal } from 'antd';
// import { useSelector } from 'react-redux';
import { Select } from '@components';
import moment from 'moment';
import { API } from '@service';
function WeeklyReport(props) {
  const now = new Date();
  const apiDateFormat = 'YYYY-MM-DD';
  const { visible, onCancel } = props;
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [dateRange, setDateRange] = useState([
    moment(now).format(apiDateFormat),
    moment(now).format(apiDateFormat),
  ]);
  const [loading, setLoading] = useState(false);
  const datePickerProps = (index) => {
    const dateFormat = 'MM/DD/YYYY';
    return {
      suffixIcon: <span className="appkiticon icon-calendar-fill" />,
      format: dateFormat,
      defaultValue: moment(now, dateFormat),
      allowClear: false,
      onChange: (e) => {
        dateRange[index] = e.format(apiDateFormat);
        setDateRange([...dateRange]);
      },
      disabledDate: (current) => current > moment().endOf('day'),
    };
  };
  const handleSelectChange = (e) => {
    if (e === 2) {
      setShowDatePicker(true);
    } else {
      setShowDatePicker(false);
    }
  };
  const handleDownload = async () => {
    setLoading(true);
    try {
      const fileNameFormat = 'M_DD_YY';
      const res = await API.downloadWeeklyReport(
        showDatePicker ? dateRange : '',
      );

      // Access res.data instead of res directly
      const blob = res.data || res;

      // Validate it's a proper Blob
      if (!(blob instanceof Blob)) {
        console.error('Response is not a Blob:', blob);
        throw new Error('Invalid response format');
      }

      const file = window.URL.createObjectURL(blob);
      const fileName = `M&A_Gateway_Projects_Downloads${
        !showDatePicker
          ? '_All'
          : `-${moment(dateRange[0]).format(fileNameFormat)}-${moment(
              dateRange[1],
            ).format(fileNameFormat)}`
      }.xlsx`;

      const a = document.createElement('a');
      a.href = file;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(file);
    } catch (error) {
      console.error('Download error:', error);
    } finally {
      setLoading(false);
    }
  };

  const isDateRangeValid = dateRange[0] <= dateRange[1];

  return (
    <Modal
      centered
      className="weekly-report-modal"
      visible={visible}
      title="Weekly Project Report Download"
      okText="Download"
      onCancel={onCancel}
      onOk={handleDownload}
      okButtonProps={{ disabled: !isDateRangeValid }}
      confirmLoading={loading}
      destroyOnClose={true}
    >
      <div className="weekly-report-content">
        <div className="title">Download Selection</div>
        <Select
          defaultValue="All Project"
          onSelect={handleSelectChange}
          dropdownClassName="weekly-report-select-dropdown"
          options={[
            { name: 'All Project', value: 1 },
            { name: 'Selected Period Project', value: 2 },
          ]}
          size="lg"
        />
        {showDatePicker ? (
          <>
            <div className="date-picker-area">
              <div>
                <div className="title">Start Date</div>
                <DatePicker {...datePickerProps(0)} />
              </div>
              <div>
                <div className="title">End Date</div>
                <DatePicker {...datePickerProps(1)} />
              </div>
            </div>
            {!isDateRangeValid && (
              <div className="error-msg">
                End Date must be a date after Start Date.
              </div>
            )}
          </>
        ) : null}
      </div>
    </Modal>
  );
}

export default memo(WeeklyReport);
